import React from "react";

import { OrderSummaryGraph } from "./line-graph";
import { OrdersMetrics } from "./metrics";
import { OrderCard } from "./order-card";

export function OrdersChart() {
  return (
    <OrderCard className="my-4 p-4">
      <div className="text-lg	font-semibold">Orders Summary</div>
      <OrdersMetrics />
      <OrderSummaryGraph />
    </OrderCard>
  );
}
